"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6824],{

/***/ 26824:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$F": function() { return /* binding */ CheckoutBtn; },
/* harmony export */   "Au": function() { return /* binding */ OptionProducts; },
/* harmony export */   "Bo": function() { return /* binding */ BtnWrapper; },
/* harmony export */   "C5": function() { return /* binding */ QtyCheckOutBtnWrapper; },
/* harmony export */   "DW": function() { return /* binding */ NPayModalWrapper; },
/* harmony export */   "Eo": function() { return /* binding */ CartBtn; },
/* harmony export */   "Go": function() { return /* binding */ ProductCommnet; },
/* harmony export */   "H1": function() { return /* binding */ SignUpCouponBox; },
/* harmony export */   "Jj": function() { return /* binding */ SalePer; },
/* harmony export */   "Ke": function() { return /* binding */ CommentWrapper; },
/* harmony export */   "My": function() { return /* binding */ Sticker; },
/* harmony export */   "NF": function() { return /* binding */ PointBox; },
/* harmony export */   "Ns": function() { return /* binding */ MakeBtnWrapper; },
/* harmony export */   "Nv": function() { return /* binding */ ProductTabWraper; },
/* harmony export */   "Ny": function() { return /* binding */ CertificationHeader; },
/* harmony export */   "Pz": function() { return /* binding */ HeaderWrapper; },
/* harmony export */   "TQ": function() { return /* binding */ CertificationContainer; },
/* harmony export */   "W2": function() { return /* binding */ Container; },
/* harmony export */   "Wf": function() { return /* binding */ TopWrapper; },
/* harmony export */   "_R": function() { return /* binding */ SoldOut; },
/* harmony export */   "bR": function() { return /* binding */ HtmlWrapper; },
/* harmony export */   "h2": function() { return /* binding */ SliderWrapper; },
/* harmony export */   "i3": function() { return /* binding */ DetailTab; },
/* harmony export */   "jt": function() { return /* binding */ BtnInfo; },
/* harmony export */   "kV": function() { return /* binding */ ProductDetailTabs; },
/* harmony export */   "nK": function() { return /* binding */ SocialPayWrapper; },
/* harmony export */   "nw": function() { return /* binding */ CertificationGrid; },
/* harmony export */   "oP": function() { return /* binding */ DiscountPrice; },
/* harmony export */   "q$": function() { return /* binding */ InfoRow; },
/* harmony export */   "qX": function() { return /* binding */ CertificationItem; },
/* harmony export */   "rh": function() { return /* binding */ OldPrice; },
/* harmony export */   "sR": function() { return /* binding */ DeliveryComment; },
/* harmony export */   "vF": function() { return /* binding */ CartTooltip; },
/* harmony export */   "vN": function() { return /* binding */ PriceWrapper; },
/* harmony export */   "vd": function() { return /* binding */ SubBtn; },
/* harmony export */   "x_": function() { return /* binding */ DetailInfo; },
/* harmony export */   "zw": function() { return /* binding */ MoreButton; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19521);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  margin: 0 auto;\n\n  .custom_prev_n {\n    left: -12% !important;\n  }\n  .custom_next_n {\n    right: -12% !important;\n  }\n  @media (max-width: 991px) {\n    .custom_prev_n {\n      left: -20% !important;\n    }\n    .custom_next_n {\n      right: -20% !important;\n    }\n  }\n  @media (max-width: 575px) {\n    .custom_prev_n {\n      display: none;\n    }\n    .custom_next_n {\n      display: none;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  margin: 50px 0 10px 0;\n  padding: 0px !important;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  width: 85%;\n  background-color: #fff;\n  overflow: hidden;\n  border: 1px solid #ececec;\n  border-radius: 15px;\n  margin-bottom: 30px;\n  position: relative;\n  @media (max-width: 1200px) {\n    width: 100%;\n  }\n\n  .mainImg {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 10px;\n    width: 100%;\n    & img {\n      min-width: 100%;\n    }\n  }\n\n  .subImg {\n    width: 100%;\n    overflow: hidden;\n    cursor: pointer;\n    z-index: 1000;\n    max-height: 8rem;\n  }\n\n  .swiper-slide {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    -webkit-justify-content: center;\n    justify-content: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    -webkit-align-items: center;\n    align-items: center;\n  }\n\n  .mySwiper {\n    padding: 0 10px;\n    margin-bottom: 10px;\n    box-sizing: border-box;\n    .swiper-slide {\n      opacity: 0.7;\n    }\n  }\n\n  .mySwiper .swiper-slide-thumb-active {\n    opacity: 1;\n    border: 1px solid #ececec;\n    border-radius: 5px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n\n  @media (max-width: 1024px) {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .title-wrapper {\n    word-break: keep-all;\n    margin-right: 80px;\n    margin-bottom: 20px;\n\n    & h4 {\n      margin-bottom: 10px;\n    }\n    & span {\n      font-size: 16px;\n    }\n\n    @media (max-width: 1024px) {\n      margin-right: 0;\n    }\n  }\n\n  .share-wish-wrapper {\n    position: absolute;\n    right: 0;\n    top: 0;\n    display: flex;\n    align-items: center;\n    gap: 0.4rem;\n\n    .action-btn {\n      cursor: pointer;\n      border: 1px solid #f1f1f1;\n      border-radius: 100%;\n      display: inline-block;\n      width: 30px;\n      height: 30px;\n      padding: 1rem;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      transition: all 0.5s ease-out 0s;\n      -webkit-transition: all 0.5s ease-out 0s;\n      font-size: 22px;\n\n      .msg-tooltip {\n        width: 350%;\n        left: -120%;\n        word-break: keep-all;\n        text-align: center;\n      }\n\n      @media (max-width: 1024px) {\n        font-size: 18px;\n        padding: 0.8rem;\n\n        .msg-tooltip {\n          padding: 6px;\n        }\n      }\n    }\n\n    @media (max-width: 1024px) {\n      position: static;\n    }\n  }\n\n  @media (min-width: 767px) and (max-width: 1024px) {\n    display: flex;\n    flex-direction: column;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;              /* \u2705 \uC804\uCCB4 \uB108\uBE44 \uC0AC\uC6A9 */\n  align-self: stretch;      /* \u2705(\uBCF4\uB108\uC2A4) \uBD80\uBAA8\uAC00 flex-column\uC774\uC5B4\uB3C4 \uB05D\uAE4C\uC9C0 \uB298\uB9AC\uAE30 */\n\n  margin-top: 10px;\n  padding-top: 28px;\n  border-top: 1px solid #f0f0f0;\n\n  .coupon-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: baseline;\n    font-weight: 600;\n  }\n\n  .label {\n    color: #ff3b30;\n    font-size: 16px;\n  }\n\n  .price {\n    color: #ff3b30;\n    font-size: 20px;\n  }\n\n  .coupon-desc {\n    margin-top: 20px;\n    font-size: 16px;\n    color: #777;\n    text-align: center;\n  }\n\n  .coupon-desc a {\n    margin-left: 4px;\n    text-decoration: underline;\n    color: #0070c9;\n    font-weight: 500;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: ",
        ";\n  align-items: start;\n  margin-top: 10px;\n  border-top: 1px solid #ececec;\n  padding-top: 20px;\n  padding-bottom: 12px;\n\n  .pricebox-top {\n    display: flex;\n    width: 100%;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 0.75rem;\n    margin-bottom: 1rem;\n\n    @media (max-width: 767px) {\n      flex-direction: column; // \uBAA8\uBC14\uC77C\uC5D0\uC11C\uB294 \uC138\uB85C\uB85C \uC815\uB82C\n      align-items: flex-start;\n    }\n  }\n\n  .pricebox-bottom {\n    display: flex;\n    width: 100%;\n    margin-top: 6px;\n  }\n\n  .title {\n    font-size: 16px;\n    margin-right: 10px;\n    margin-top: auto;\n    margin-bottom: auto;\n    min-width: 100px;\n    color: #696969;\n  }\n\n  .qty-wrapper {\n  margin: auto 0;\n\n  /* =========================\n     \uC218\uB7C9 \uBC15\uC2A4\n     ========================= */\n  .detail-qty {\n    margin: 0 5px 0 0;\n    background: #fff;\n\n    border: 2px solid #3bb77e !important;\n    border-radius: 5px;\n\n    width: 22%;\n    min-width: 90px;\n    height: 44px;\n\n    position: relative;\n    padding: 0 !important;\n    overflow: hidden;\n\n    font-size: 16px;\n    font-weight: 700;\n    color: #3bb77e;\n\n    /* \uC624\uB978\uCABD up/down \uB808\uC77C \uD3ED */\n    --qty-rail-width: 28px;\n  }\n\n  /* =========================\n     \uC22B\uC790 (\uB808\uC77C \uC81C\uC678 \uC911\uC559)\n     ========================= */\n  .detail-qty .qty-val {\n    position: absolute;\n    top: 50%;\n\n    /* \u2705 up/down \uB808\uC77C \uD3ED\uC758 \uC808\uBC18\uB9CC\uD07C \uBCF4\uC815 */\n    left: calc(50% - (var(--qty-rail-width) / 2));\n\n    transform: translate(-50%, -50%);\n    line-height: 1;\n    white-space: nowrap;\n    pointer-events: none;\n  }\n\n  /* =========================\n     up / down \uBC84\uD2BC (\uC624\uB978\uCABD \uC138\uB85C)\n     ========================= */\n  .detail-qty .qty-up,\n  .detail-qty .qty-down {\n    position: absolute;\n    right: 0;\n    width: var(--qty-rail-width);\n    height: 50%;\n\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    cursor: pointer;\n    text-decoration: none;\n    background: #fff;\n  }\n\n  .detail-qty .qty-up {\n    top: 0;\n    border-left: 1px solid #e5e5e5;\n    border-bottom: 1px solid #e5e5e5; /* \uAD6C\uBD84\uC120 */\n  }\n\n  .detail-qty .qty-down {\n    bottom: 0;\n    border-left: 1px solid #e5e5e5;\n  }\n\n  /* \uC544\uC774\uCF58 \uC815\uB82C \uC548\uC815\uD654 */\n  .detail-qty .qty-up i,\n  .detail-qty .qty-down i {\n    font-size: 16px;\n    line-height: 1;\n    color: #3bb77e;\n  }\n\n  /* hover \uC2DC\uB9CC \uBC84\uD2BC \uC778\uC9C0 */\n  .detail-qty .qty-up:hover,\n  .detail-qty .qty-down:hover {\n    background-color: #f8f8f8;\n  }\n\n  /* =========================\n     \uD558\uB2E8 \uBE60\uB978 \uC218\uB7C9 \uBC84\uD2BC\n     ========================= */\n  .qty-quick-add {\n    margin-top: 4px;\n    display: flex;\n    justify-content: center;\n    gap: 3px;\n    width: 100%;\n  }\n\n  .qty-quick-add .quick-btn {\n    height: 26px;\n    min-width: 40px;\n    padding: 0 10px;\n\n    background: #fff;\n    border: 1px solid #e5e5e5;\n    border-radius: 6px;\n\n    font-size: 12px;\n    font-weight: 600;\n    color: #333;\n\n    cursor: pointer;\n  }\n\n  .qty-quick-add .quick-btn:hover {\n    border-color: #3bb77e;\n    color: #3bb77e;\n  }\n\n  /* =========================\n     \uBAA8\uBC14\uC77C \uBBF8\uC138 \uC870\uC815\n     ========================= */\n  @media (max-width: 420px) {\n    .detail-qty {\n      height: 42px;\n      min-width: 80px;\n    }\n\n    .detail-qty {\n      --qty-rail-width: 26px;\n    }\n\n    .detail-qty .qty-up i,\n    .detail-qty .qty-down i {\n      font-size: 15px;\n    }\n  }\n}\n\n\n\n  .price {\n    margin: auto 0 auto auto;\n    /* margin-top: auto;\n    margin-left: auto; */\n  }\n\n  .no-saleper-price {\n    margin-top: auto;\n    margin-bottom: 12.5px;\n    margin-left: auto;\n  }\n\n  .old-price {\n    width: 100%;\n    display: flex;\n    margin-bottom: 10px;\n    @media screen and (max-width: 960px) {\n      justify-content: flex-end;\n    }\n  }\n\n  .discount_price {\n    display: flex;\n    justify-content: end;\n    font-size: 28px;\n    font-weight: 600;\n    padding-bottom: 2px;\n    @media screen and (max-width: 460px) {\n      font-size: 24px;\n    }\n    @media screen and (max-width: 350px) {\n      font-size: 20px;\n    }\n  }\n  margin-bottom: 10px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  text-decoration: line-through;\n  color: #b6b6b6;\n  font-size: 18px;\n  font-weight: 700;\n  display: block;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  font-weight: 600;\n  display: block;\n  color: #e74c3c;\n  font-size: 20px;\n  margin-right: 10px;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 35px;\n  text-decoration: none;\n  font-weight: 700;\n  margin-bottom: 10px;\n  @media screen and (max-width: 960px) {\n    font-size: 30px;\n    width: 100%;\n    text-align: end;\n  }\n  @media screen and (max-width: 350px) {\n    font-size: 24px;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  width: fit-content;\n  display: flex;\n  align-items: center;\n  font-size: 13px;\n  border-radius: 15px;\n  position: relative;\n  margin-left: auto;\n\n  .infoIcon {\n    width: 7px;\n    height: 7px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border: 1px solid #58585f;\n    border-radius: 100%;\n    padding: 7px;\n    font-size: 5px;\n    margin-left: 5px;\n    cursor: pointer;\n    :hover {\n      border-color: #3bb77e;\n      color: #3bb77e;\n    }\n  }\n\n  .info {\n    text-align: center;\n    word-break: keep-all;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 1rem;\n  height: 1rem;\n  font-size: 12px;\n  color: white;\n  background-color: #3bb77e;\n  border: 1px solid white;\n  border-radius: 1rem;\n  margin-right: 5px;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  text-align: center;\n  background: #fff;\n  border: 2px solid #757575;\n  font-size: 16px;\n  font-weight: 700;\n  color: #757575;\n  border-radius: 5px;\n  margin-right: 10px;\n  padding: 10px;\n  max-width: 10rem;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  border-top: 1px solid #ececec;\n  padding-top: 10px;\n  margin-bottom: 10px;\n  .print-btn {\n    margin-top: 10px;\n    width: 100%;\n    font-weight: 500;\n    font-size: 1rem;\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n\n  .btnBox {\n    width: 100%;\n    height: 50px;\n    display: flex;\n    justify-content: space-between;\n    gap: 0.5rem;\n  }\n\n  @media (min-width: 767px) and (max-width: 1024px) {\n    width: 100%;\n    margin-right: 0;\n    margin-bottom: 5px;\n  }\n  @media (max-width: 511px) {\n    width: 100%;\n    margin-right: 0;\n    margin-bottom: 5px;\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n  margin: ",
        ";\n  width: ",
        ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border: 2px solid #3bb77e;\n  background-color: #3bb77e;\n  color: #fff;\n  border-radius: 5px;\n  word-break: keep-all;\n  font-size: 1rem;\n  font-weight: 500;\n\n  :hover {\n    background-color: #ffc107;\n    border-color: #ffc107;\n  }\n\n  /* @media (min-width: 767px) and (max-width: 1024px) {\n    margin-right: 5px;\n    :last-of-type {\n      margin-right: 0px;\n    }\n  }\n  @media (max-width: 511px) {\n    margin-right: 5px;\n    :last-of-type {\n      margin-right: 0px;\n    }\n  } */\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "\n  margin: 0;\n  width: auto;\n  min-width: auto;\n  padding: 0.5rem 1rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border: 1px solid #58585f;\n  background-color: white;\n  color: #58585f;\n  border-radius: 5px;\n  word-break: keep-all;\n  font-size: 0.8rem;\n  font-weight: 500;\n  height: 40px;\n  white-space: nowrap;\n\n  :hover {\n    background-color: #ffc107;\n    border-color: #ffc107;\n  }\n\n  @media (max-width: 767px) {\n    width: 100%; // \uBAA8\uBC14\uC77C\uC5D0\uC11C\uB294 \uC804\uCCB4 \uB108\uBE44\n    font-size: 0.75rem;\n  }\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  padding: 1px 6px;\n  background-color: ",
        ";\n  border: ",
        ";\n  border-radius: 5px;\n  display: inline-block;\n  width: 50%;\n  height: 50px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 1rem;\n  font-weight: 500;\n  color: #fff;\n\n  &:hover {\n    background: ",
        ";\n    color: #fff;\n  }\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  bottom: 105%;\n  width: fit-content;\n  border: 1px solid #ececec;\n  border-radius: 5px;\n  padding: 10px 15px 15px 15px;\n  background-color: #fff;\n  font-size: 13px;\n  color: #333;\n  z-index: 999;\n  cursor: default;\n\n  .tooltip-msg {\n    margin: 8px 0;\n  }\n\n  @media (min-width: 992px) and (max-width: 1199px) {\n    width: 104%;\n  }\n\n  @media (min-width: 767px) and (max-width: 991px) {\n    width: 146%;\n  }\n\n  @media (max-width: 510px) {\n    width: 110%;\n    word-break: keep-all;\n    padding: 6px 10px;\n  }\n\n  .btnWrapper {\n    display: flex;\n    justify-content: space-between;\n    gap: 6px;\n\n    .move-cart {\n      background-color: #f97316;\n      font-weight: 500;\n    }\n\n    .keep-shopping {\n      /* border: 2px solid #3bb77e; */\n\n      background-color: #3bb77e;\n      font-weight: 500;\n    }\n  }\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  left: auto;\n  bottom: 110%;\n  width: 120%;\n  background-color: #fff;\n  color: #333;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 12px;\n  -webkit-transition: all 0.25s ease 0s;\n  transition: all 0.25s ease 0s;\n  border: 1px solid #ececec;\n  border-radius: 5px;\n  padding: 10px 10px;\n  -webkit-box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.05);\n  box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.05);\n  z-index: 999;\n  display: flex;\n  flex-direction: column;\n\n  @media (max-width: 575px) {\n    /* width: 100%; */\n    left: -10%;\n  }\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: 50px;\n\n  .social-payment {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 10px;\n    width: 50%;\n\n    .kakao-btn {\n      cursor: pointer;\n      width: 90%;\n      height: 50px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      background-color: #ffeb00;\n      color: #333;\n      border-radius: 5px;\n      font-size: 16px;\n      & img {\n        max-width: 70px;\n        margin-right: 2px;\n      }\n    }\n    .naver-btn {\n      cursor: pointer;\n      width: 80%;\n      height: 50px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      background-color: #00c13c;\n      color: #fff;\n      border-radius: 5px;\n      font-size: 16px;\n      & img {\n        max-width: 60px;\n        margin-right: 10px;\n      }\n      transition: 0.3s ease;\n\n      :hover {\n        background-color: #ffc107;\n        transition: 0.3s ease;\n      }\n    }\n    .pick {\n      cursor: pointer;\n      border: 1px solid #f1f1f1;\n      border-radius: 5px;\n      display: inline-block;\n      width: 20%;\n      height: 50px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      transition: all 0.3s ease 0s;\n      -webkit-transition: all 0.3s ease 0s;\n      font-size: 16px;\n      margin-left: 5px;\n      :hover {\n        background-color: #00c13c;\n        color: #fff;\n      }\n    }\n    @media screen and (max-width: 511px) {\n      .naver-btn {\n        width: 80%;\n      }\n      .pick {\n        min-width: 20%;\n      }\n    }\n  }\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: 10px;\n  border-top: 1px solid #ececec;\n  padding-top: 10px;\n  word-break: keep-all;\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-top: 1px solid #ececec;\n  padding-top: 10px;\n  margin-bottom: 10px;\n  margin-top: 5px;\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 14px;\n  & li {\n    color: #253d4e;\n  }\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = _taggedTemplateLiteral([
        "\n  width: 40%;\n  height: 50px;\n  display: flex;\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: 5px;\n  padding-left: 20px;\n  & li {\n    list-style: disc;\n    color: #253d4e;\n  }\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 0;\n  border-top: none;\n  padding: 50px 0px;\n\n  .shop_info_tab {\n    margin: 30px auto;\n  }\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = _taggedTemplateLiteral([
        "\n  max-width: 100%;\n  & figure {\n    max-width: 100%;\n  }\n"
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = _taggedTemplateLiteral([
        "\n  position: fixed;\n  top: 0;\n  left: 0;\n  background-color: rgba(0, 0, 0, 0.8);\n  z-index: 10000001;\n  width: 100vw;\n  height: 100vh;\n  display: flex;\n\n  .modal-section {\n    width: fit-content;\n    margin: auto;\n    background-color: white;\n    overflow: auto;\n    border: none;\n    display: flex;\n    flex-direction: column;\n    border-radius: 20px;\n    padding: 30px;\n    & > i {\n      font-size: 2rem;\n      color: black;\n      cursor: pointer;\n      :hover {\n        color: #3bb77e;\n      }\n    }\n    @media (max-width: 767px) {\n      padding: 10px;\n      width: 75vw;\n      left: 25vw;\n    }\n    @media (max-width: 575px) {\n      padding: 10px;\n      width: 100vw;\n    }\n  }\n\n  .modal-content {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    border: none;\n    margin: 0 auto;\n    .close_icon {\n      cursor: pointer;\n      width: 30px;\n      margin-left: auto;\n    }\n\n    .desc {\n      text-align: center;\n      margin-bottom: 20px;\n      padding: 10px 50px;\n      font-size: 1rem;\n      color: #58585f;\n\n      & figure {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        width: 400px;\n        margin: 0px auto 10px;\n      }\n\n      @media (max-width: 575px) {\n        padding: 10px 10px;\n      }\n    }\n\n    .btnWrapper {\n      display: flex;\n      gap: 10px;\n      align-items: center;\n      justify-content: space-between;\n\n      & span {\n        cursor: pointer;\n        width: 100%;\n        border-radius: 10px;\n        color: #fff;\n        text-align: center;\n        padding: 10px 0px;\n        :hover {\n          opacity: 0.8;\n        }\n      }\n      .confirm {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        & img {\n          width: 50px;\n          margin-right: 5px;\n        }\n      }\n      .cancel {\n        background-color: #80bdff;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        height: 47px;\n        font-size: 16px;\n        margin-bottom: 5px;\n      }\n    }\n    @media (max-width: 767px) {\n    }\n  }\n"
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = _taggedTemplateLiteral([
        "\n  position: sticky;\n  top: 0px;\n  width: 100%;\n  display: flex;\n  padding: 0px 0px;\n  z-index: 9;\n"
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  padding: 20px;\n  border: 1px solid #ececec;\n  cursor: pointer;\n  font-size: 18px;\n  font-weight: 500;\n  text-align: center;\n  background-color: ",
        ";\n  color: ",
        ";\n\n  :first-of-type {\n    border-right: none;\n  }\n"
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 30px 0px;\n  & table {\n    margin-bottom: 0px;\n  }\n"
    ]);
    _templateObject31 = function _templateObject31() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  margin-bottom: 30px;\n  //border: 1px solid #ececec;\n\n  border-top: 3px solid #ececec;\n  border-bottom: 3px solid #ececec;\n  border-left: 1px solid #ececec;\n  border-right: 1px solid #ececec;\n"
    ]);
    _templateObject32 = function _templateObject32() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = _taggedTemplateLiteral([
        "\n  text-align: center;\n  padding: 20px 10px;\n  background-color: #f8f8f8;\n  border-bottom: 1px solid #ececec;\n\n  h3 {\n    font-size: 20px;\n    font-weight: 600;\n    margin-bottom: 5px;\n  }\n\n  p {\n    font-size: 16px;\n    color: #666;\n    margin: 0;\n  }\n"
    ]);
    _templateObject33 = function _templateObject33() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  padding: 0;\n  margin: 0 auto;\n\n  @media (max-width: 768px) {\n    flex-direction: ",
        ";\n    align-items: center;\n  }\n\n  @media (max-width: 480px) {\n    flex-direction: column;\n    align-items: center;\n  }\n"
    ]);
    _templateObject34 = function _templateObject34() {
        return data;
    };
    return data;
}
function _templateObject35() {
    var data = _taggedTemplateLiteral([
        '\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 15px 10px 25px;\n  flex: 1;\n  max-width: none;\n  position: relative;\n\n  /* Add border-left for items except the first one */\n  &:not(:first-child) {\n    border-left: 1px solid #ececec;\n  }\n\n  /* For mobile, remove left borders and add top borders instead */\n  @media (max-width: 480px) {\n    &:not(:first-child) {\n      border-left: none;\n      border-top: 1px solid #ececec;\n    }\n  }\n\n  .icon-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 80px;\n    margin-bottom: 15px;\n\n    img {\n      max-height: 100%;\n      max-width: 100%;\n    }\n  }\n\n  .cert-name {\n    font-size: 16px;\n    font-weight: 500;\n    display: flex;\n    align-items: center;\n    margin-bottom: 5px;\n    text-align: center;\n\n    &:before {\n      content: "\u2713";\n      display: inline-block;\n      margin-right: 5px;\n      color: #3bb77e;\n    }\n  }\n\n  .cert-description {\n    font-size: 14px;\n    color: #888;\n    text-align: center;\n  }\n'
    ]);
    _templateObject35 = function _templateObject35() {
        return data;
    };
    return data;
}
function _templateObject36() {
    var data = _taggedTemplateLiteral([
        "\n  text-align: center;\n  padding: 15px 0;\n  border-top: 1px solid #ececec;\n\n  button {\n    background: none;\n    border: none;\n    font-size: 14px;\n    font-weight: 600;\n    color: #666;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 0 auto;\n    transition: color 0.3s ease;\n\n    &:hover {\n      color: #3bb77e;\n    }\n  }\n\n  i {\n    margin-left: 5px;\n  }\n"
    ]);
    _templateObject36 = function _templateObject36() {
        return data;
    };
    return data;
}

var Container = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    componentId: "sc-d7cfcc40-0"
})(_templateObject());
var TopWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d7cfcc40-1"
})(_templateObject1());
var SliderWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d7cfcc40-2"
})(_templateObject2());
// 상단 상품정보
var DetailInfo = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d7cfcc40-3"
})(_templateObject3());
// 제목
var HeaderWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d7cfcc40-4"
})(_templateObject4());
var SignUpCouponBox = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d7cfcc40-5"
})(_templateObject5());
// 가격
var PriceWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d7cfcc40-6"
})(_templateObject6(), function(props) {
    return props.totalPrice ? "column" : "row";
});
var OldPrice = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-d7cfcc40-7"
})(_templateObject7());
var SalePer = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-d7cfcc40-8"
})(_templateObject8());
var DiscountPrice = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-d7cfcc40-9"
})(_templateObject9());
var PointBox = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d7cfcc40-10"
})(_templateObject10());
var Sticker = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-d7cfcc40-11"
})(_templateObject11());
// SoldOut
var SoldOut = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d7cfcc40-12"
})(_templateObject12());
// 버튼 구역
var BtnWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d7cfcc40-13"
})(_templateObject13());
var QtyCheckOutBtnWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d7cfcc40-14"
})(_templateObject14());
var CheckoutBtn = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-d7cfcc40-15"
})(_templateObject15(), function(props) {
    return props.noMargin ? "" : "0 5px 0 0";
}, function(props) {
    return props.inquiry === "Y" ? "50%" : "100%";
});
var SubBtn = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-d7cfcc40-16"
})(_templateObject16());
var CartBtn = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].a.withConfig */ .ZP.a.withConfig({
    componentId: "sc-d7cfcc40-17"
})(_templateObject17(), function(props) {
    return props.isStored ? "#FF9E5B" : "#077edc";
}, function(props) {
    return props.isStored ? "2px solid FF9E5B" : "2px solid 077edc";
}, function(props) {
    return props.isStored ? "" : "#ffc107";
});
var CartTooltip = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d7cfcc40-18"
})(_templateObject18());
var BtnInfo = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d7cfcc40-19"
})(_templateObject19());
var SocialPayWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d7cfcc40-20"
})(_templateObject20());
// comment
var CommentWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d7cfcc40-21"
})(_templateObject21());
var InfoRow = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d7cfcc40-22"
})(_templateObject22());
var DeliveryComment = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ul.withConfig */ .ZP.ul.withConfig({
    componentId: "sc-d7cfcc40-23"
})(_templateObject23());
var MakeBtnWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d7cfcc40-24"
})(_templateObject24());
var ProductCommnet = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ul.withConfig */ .ZP.ul.withConfig({
    componentId: "sc-d7cfcc40-25"
})(_templateObject25());
// productTab
var ProductTabWraper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d7cfcc40-26"
})(_templateObject26());
var HtmlWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d7cfcc40-27"
})(_templateObject27());
var NPayModalWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d7cfcc40-28"
})(_templateObject28());
var ProductDetailTabs = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d7cfcc40-29"
})(_templateObject29());
var DetailTab = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d7cfcc40-30"
})(_templateObject30(), function(props) {
    return props.active ? "#fff" : "#f6f6f6";
}, function(props) {
    return props.active ? "#3bb77e" : "#235d4e";
});
var OptionProducts = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d7cfcc40-31"
})(_templateObject31());
var CertificationContainer = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d7cfcc40-32"
})(_templateObject32());
/* Keep the header with slightly improved spacing */ var CertificationHeader = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d7cfcc40-33"
})(_templateObject33());
/* Fix the grid to properly display certification items in a row */ var CertificationGrid = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d7cfcc40-34"
})(_templateObject34(), function(props) {
    return props.itemCount > 2 ? "row" : "column";
});
/* Improve certification item styling */ var CertificationItem = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d7cfcc40-35"
})(_templateObject35());
/* Update the more button styling */ var MoreButton = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d7cfcc40-36"
})(_templateObject36());


/***/ })

}]);